export enum SupportId {
    DEFAULT = "E9999",
    TRIAL_EXPIRED = "E4003",
    FORM_DATA_PARSING_ERROR = "E4004",
    WRONG_CONTEXT_TOKEN = "E4005",
    CREATE_COMPLEX_ORDER_BONUS_FAILED = "E4006",
    UPDATE_ORDER_BONUS_FAILED = "E4007",
    ORDER_BONUS_UNPROCESSABLE_VARIANT_CONFIGURATION = "E4008",
    DELETE_COMPLEX_ORDER_BONUS_FAILED = "E4009",
    REGISTRATION_CONNECTION_FAILED = "E4010",
}
